import { Star } from "lucide-react";

const testimonials = [
  {
    "address": "Whispering Willow DR",
    "role_represented": "Buyer",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "Az O",
    "date_posted": "Dec 04, 2024",
    "comment": "Bernadette made the process so quick and simple. I'm glad I got the opportunity to work with her. I highly recommend her."
  },
  {
    "address": "Mersea DR",
    "role_represented": "Buyer",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "Joy L",
    "date_posted": "May 08, 2025",
    "comment": "Great customer service and always on time Well explained details"
  },
  {
    "address": "Palm Tree LN",
    "role_represented": "Buyer",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "Wyonita B",
    "date_posted": "May 29, 2025",
    "comment": ""
  },
  {
    "address": "Ashford Creek DR",
    "role_represented": "Buyer",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "San L",
    "date_posted": "Apr 01, 2025",
    "comment": "I feel so fortunate to have found Bernadette. I could not ask for a more attentive realtor. She was consistently attentive, patient knowledgeable, communicative, and all around thoughtful individual."
  },
  {
    "address": "Cathedral Bend Dr",
    "role_represented": "Seller",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "Taylor O",
    "date_posted": "Dec 01, 2024",
    "comment": "Bernadette made the process of finding our new home seamless and stress free. The unknown of moving across country is never easy, but she was always available for any questions no matter the time of day. We will absolutely be contacting Bernadette again when we re ready to purchase our next home. Highly recommend"
  }, 

  {
    "address": "Crystal Stream DR",
    "role_represented": "Buyer",
    "rating_overall": "5/5",
    "ratings_detail": {
      "competency": "5/5",
      "knowledge": "5/5",
      "communication": "5/5",
      "experience": "5/5"
    },
    "reviewer_name": "Lisa S",
    "date_posted": "Nov 26, 2024",
    "comment": ""
  }
]

export const TestimonialsSection = () => {
  return (
    <section className="py-8 sm:py-16 lg:py-24 bg-gradient-to-b from-white via-purple-50/30 to-white overflow-hidden">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-20">
          <div className="inline-block mb-3 sm:mb-4">
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-semibold tracking-wide uppercase">
              ⭐ Trusted by Thousands
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 lg:mb-6 text-gray-900 px-2">
            What Our Clients
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Are Saying
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Real results from real people who successfully navigated their home buying journey
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-7xl mx-auto mb-8 sm:mb-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative bg-white border-2 border-gray-100 rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2 p-4 sm:p-6 lg:p-8 flex flex-col">
              {/* Quote Icon */}
              <div className="absolute top-4 right-4 sm:top-6 sm:right-6 opacity-10 group-hover:opacity-20 transition-opacity">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-purple-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                </svg>
              </div>

              {/* Star Rating */}
              <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 fill-yellow-400 text-yellow-400 drop-shadow-sm"
                  />
                ))}
              </div>

              {/* Comment */}
              {testimonial.comment ? (
                <blockquote className="text-gray-700 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base lg:text-lg font-medium flex-grow">
                  "{testimonial.comment}"
                </blockquote>
              ) : (
                <div className="text-gray-400 italic mb-4 sm:mb-6 text-sm flex-grow">
                  Verified 5-star review
                </div>
              )}

              {/* Reviewer Info */}
              <div className="border-t-2 border-purple-100 pt-3 sm:pt-4 lg:pt-5 mt-auto">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-base sm:text-lg text-gray-900 mb-1 truncate">
                      {testimonial.reviewer_name}
                    </div>
                    <div className="mb-2">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-purple-100 text-purple-800 capitalize">
                        {testimonial.role_represented}
                      </span>
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      📍 {testimonial.address}
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <div className="text-xs font-bold text-purple-600 bg-purple-50 px-2 py-1 rounded whitespace-nowrap">
                      {testimonial.rating_overall}
                    </div>
                    <div className="text-xs text-gray-400 mt-1 whitespace-nowrap">
                      {testimonial.date_posted}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl sm:rounded-3xl shadow-2xl p-6 sm:p-8 lg:p-12">
          <div className="grid grid-cols-3 gap-3 sm:gap-6 lg:gap-12 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-1 sm:mb-2">
                5K+
              </div>
              <div className="text-xs sm:text-sm md:text-base lg:text-lg text-purple-100 font-medium">
                Happy Clients
              </div>
            </div>
            <div className="text-center border-x border-purple-400/30">
              <div className="flex flex-col sm:flex-row items-center justify-center mb-1 sm:mb-2 gap-1">
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white">4.9</span>
                <div className="flex gap-0.5 sm:ml-2">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-2 h-2 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5 fill-yellow-300 text-yellow-300"
                    />
                  ))}
                </div>
              </div>
              <div className="text-xs sm:text-sm md:text-base lg:text-lg text-purple-100 font-medium">
                Avg Rating
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-1 sm:mb-2">
                98%
              </div>
              <div className="text-xs sm:text-sm md:text-base lg:text-lg text-purple-100 font-medium">
                Recommend
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
